import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MfaRoutingModule } from './mfa-routing.module';



@NgModule({
  imports: [
    CommonModule,
    MfaRoutingModule
  ]
})
export class MfaModule { }
